export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1542314831-068cd1dbfeeb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBtb2Rlcm4lMjBtYW5zaW9uJTIwcG9vbCUyMG5pZ2h0fGVufDB8fHx8MTc4NjM4MzUxMnww&ixlib=rb-4.1.0&q=85",
  jet: "https://images.unsplash.com/photo-1625513123245-fcb02d69ad12?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwxfHxwcml2YXRlJTIwamV0JTIwaW50ZXJpb3IlMjBsdXh1cnl8ZW58MHx8fHwxNzg2MzgzNDk1fDA&ixlib=rb-4.1.0&q=85",
  yacht: "https://images.pexels.com/photos/17537156/pexels-photo-17537156.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  chauffeur: "https://images.unsplash.com/photo-1696233016084-30c8345d85ff?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBjaGF1ZmZldXIlMjByb2xscyUyMHJveWNlfGVufDB8fHx8MTc4NjM4MzUxMnww&ixlib=rb-4.1.0&q=85",
  dining: "https://images.unsplash.com/photo-1784981260280-38514a2c6bf6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwzfHxtaWNoZWxpbiUyMHN0YXIlMjBmaW5lJTIwZGluaW5nJTIwbHV4dXJ5fGVufDB8fHx8MTc4NjM4MzUxMnww&ixlib=rb-4.1.0&q=85",
  gloves: "https://images.unsplash.com/photo-1685968559503-23a4d0223d84?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBjb25jaWVyZ2UlMjBzZXJ2aWNlJTIwd2hpdGUlMjBnbG92ZXxlbnwwfHx8MTc4NTM3Mzc1MHww&ixlib=rb-4.1.0&q=85",
  penthouse: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=1600&q=80",
  supercar: "https://images.unsplash.com/photo-1503376780353-7e6692767b70?auto=format&fit=crop&w=1200&q=80",
  wellness: "https://images.unsplash.com/photo-1544161515-4ab6ce6db874?auto=format&fit=crop&w=1200&q=80",
  security: "https://images.unsplash.com/photo-1560250097-0b93528c311a?auto=format&fit=crop&w=1200&q=80",
  daily: "https://images.unsplash.com/photo-1551882547-ff40c63fe5fa?auto=format&fit=crop&w=1200&q=80",
  cta: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=2000&q=80",
};

export const CONTACT = {
  phone: "+44 (0) 207 126 8237",
  email: "info@deluxconcierge.com",
  address: "20-22 Wenlock Road, N1 7GU London, United Kingdom",
};

export const DESTINATIONS = [
  "London", "Paris", "Monaco", "Dubai", "Marbella", "Lake Como", "St. Tropez",
  "Geneva", "Milan", "Ibiza", "New York", "Miami", "The Caribbean", "Bora-Bora",
  "Mauritius", "Seychelles", "Qatar", "Kuwait",
];

export const SERVICES = [
  {
    id: "luxury-travel",
    name: "Luxury Travel",
    tagline: "Bespoke travel experiences. Curated for you.",
    headline: "Extraordinary journeys.",
    headlineItalic: "Effortlessly.",
    description: "From private islands to cultural escapes, we design bespoke journeys that inspire — and create memories to last a lifetime.",
    image: "/images/svc-travel.jpeg",
    secondary: "/images/tr-1.jpeg",
    heroSecondLabel: "Discover Destinations",
    features: [
      "Bespoke holiday packages, tailored to you",
      "Transportation and accommodation arranged",
      "Villas, resorts, private islands and luxury cruises worldwide",
      "On-trip concierge, around the clock",
    ],
    destinations: [
      { name: "Maldives", tagline: "Overwater villas and turquoise lagoons.", image: "/images/rot-2.jpeg" },
      { name: "Japan", tagline: "Tradition, culture and modern luxury.", image: "https://images.unsplash.com/photo-1493976040374-85c8e12f0c0e?auto=format&fit=crop&w=1200&q=80" },
      { name: "Santorini", tagline: "Iconic views and romantic sunsets.", image: "https://images.unsplash.com/photo-1613395877344-13d4a8e0d49e?auto=format&fit=crop&w=1200&q=80" },
      { name: "Dubai", tagline: "Luxury, adventure and world-class dining.", image: "/images/svc-realestate.jpeg" },
      { name: "Switzerland", tagline: "Alpine retreats and winter elegance.", image: "/images/rot-7.jpeg" },
      { name: "Bora-Bora", tagline: "Barefoot luxury at the edge of the world.", image: "/images/hero-beach.jpeg" },
    ],
  },
  {
    id: "private-jet-charter",
    name: "Private Jet Charter",
    tagline: "The fastest aircraft in the sky, ready when you are.",
    description: "From late-night departures to transcontinental itineraries, we place you aboard the finest private aircraft at a moment's notice — every detail handled before you arrive at the terminal.",
    image: IMAGES.jet,
    secondary: "/images/air-alps.webp",
    features: [
      "Global fleet access, wheels-up in hours",
      "Dedicated flight concierge and catering",
      "Helicopter transfers direct to the tarmac",
      "Pet-friendly, family-ready cabins",
    ],
    gallery: ["/images/jc-1.jpeg", "/images/jc-3.jpeg", "/images/air-alps.webp", "/images/jc-2.jpeg", "/images/jc-5.jpeg", "/images/jc-6.jpeg", "/images/jc-7.jpeg", "/images/jc-8.jpeg", "/images/jc-9.jpeg", IMAGES.jet, "/images/air-phenom300.jpg"],
    fleet: [
      { type: "Light Jet", name: "Phenom 300", pax: 7, range: "4 hrs", note: "Ideal for short trips and quick getaways.", image: "/images/air-phenom300.jpg" },
      { type: "Midsize Jet", name: "Citation XLS+", pax: 8, range: "5 hrs", note: "Perfect balance of range, comfort and efficiency.", image: "/images/air-citationxls.jpg" },
      { type: "Super Midsize Jet", name: "Hawker 900XP", pax: 8, range: "6 hrs", note: "Spacious cabin and transcontinental range.", image: "/images/air-hawker900.jpg" },
      { type: "Heavy Jet", name: "Gulfstream G450", pax: 14, range: "8 hrs", note: "Long range, exceptional comfort and performance.", image: "/images/air-gulfstream.jpg" },
      { type: "Ultra Long Range", name: "Bombardier Global 7500", pax: 16, range: "12+ hrs", note: "Fly further. Arrive fully refreshed.", image: "/images/air-global7500.jpg" },
    ],
  },
  {
    id: "helicopter-charter",
    name: "Helicopter Charter",
    tagline: "Private helicopter charter. The fastest way between two points.",
    headline: "Above the traffic.",
    headlineItalic: "Beyond the schedule.",
    description: "From airport transfers in minutes to direct arrivals at yachts, estates and events, our private helicopter charters turn journeys into moments — discreet, effortless and always on your schedule.",
    image: "/images/heli-main.jpg",
    secondary: "/images/heli-1.jpg",
    features: [
      "Airport and city-to-city transfers in minutes",
      "Direct access to yachts, estates and private events",
      "Scenic tours and bespoke flight itineraries",
      "VIP twin-engine aircraft with experienced captains",
    ],
    gallery: ["/images/heli-1.jpg", "/images/heli-2.jpg", "/images/heli-3.jpg", "/images/heli-4.jpg", "/images/heli-5.jpg", "/images/heli-6.jpg", "/images/heli-main.jpg"],
  },
  {
    id: "yacht-charter",
    name: "Yacht Charter",
    tagline: "Sail the world's most luxurious yachts — or build your own.",
    headline: "The open water.",
    headlineItalic: "Entirely yours.",
    description: "We don't simply charter the world's most extraordinary yachts; we help you design and build your very own, with crew, itineraries and berths arranged to perfection.",
    image: IMAGES.yacht,
    secondary: "/images/yacht-main.jpeg",
    featuresIntro: "Our yacht charter services include:",
    features: [
      "Bespoke Yacht Selection",
      "Fully Crewed Charters",
      "Bespoke Itinerary Planning",
      "Onboard Experiences",
      "Dining & Provisioning",
      "Onshore Experiences",
      "Transfers & Travel Logistics",
      "Berthing & Marina Arrangements",
      "Special Occasions",
      "Charter Management",
      "Yacht Acquisition & Advisory",
    ],
    gallery: ["/images/yg-1.jpeg", "/images/yg-2.jpeg", "/images/yg-3.jpeg", "/images/yacht-2.jpg", "/images/yg-5.jpeg", "/images/yg-6.jpeg"],
  },
  {
    id: "real-estate",
    name: "Real Estate",
    tagline: "Bespoke real estate solutions. Worldwide.",
    headline: "Prime properties.",
    headlineItalic: "Exclusive opportunities.",
    description: "From acquisition to management, we provide tailored real estate services across the world's most exclusive locations.",
    externalUrl: "https://www.deluxrealestate.com",
    externalLabel: "Visit DeluxRealEstate.com",
    heroSecondLabel: "Explore Properties",
    pillarsOverline: "Delux Real Estate Services",
    pillarsHeading: "End-to-end real estate solutions.",
    pillarsText: "From sourcing to management, we provide tailored real estate solutions across the world's most exclusive locations.",
    pillars: [
      { icon: "KeyRound", title: "Property Acquisition", text: "Sourcing and securing the finest opportunities." },
      { icon: "Handshake", title: "Property Disposal", text: "Discreet, strategic sales and exits." },
      { icon: "Search", title: "Property Sourcing", text: "Off-market access through our global network." },
      { icon: "Building2", title: "Property Management", text: "Complete care of your portfolio." },
      { icon: "Wrench", title: "Property Maintenance", text: "Proactive upkeep by trusted contractors." },
      { icon: "Paintbrush", title: "Interior Design", text: "Bespoke interiors by leading designers." },
      { icon: "Trees", title: "Landscaping", text: "Gardens and grounds, beautifully kept." },
      { icon: "Ruler", title: "Architecture", text: "Design, planning and build advisory." },
    ],
    image: "/images/svc-realestate.jpeg",
    secondary: IMAGES.cta,
    features: [
      "Off-market residences, estates and penthouses",
      "Acquisition, disposal and sourcing support",
      "Property management and care",
      "Trusted advisors in London, Dubai and Monaco",
    ],
    gallery: ["/images/re-stairs.jpeg", "/images/re-villa.jpeg", "/images/re-mansion.jpeg", "/images/re-bath.jpeg"],
  },
  {
    id: "security",
    name: "Security",
    tagline: "Specialist security solutions. Tailored to you.",
    headline: "Protection. Discretion.",
    headlineItalic: "Peace of mind.",
    description: "From close protection to risk assessments, our team delivers specialist security services for you, your family and your assets.",
    image: "/images/sec-1.jpeg",
    secondary: "/images/sec-2.jpeg",
    pillarsOverline: "Our Security Services",
    pillarsHeading: "Expertise when it matters most.",
    pillarsText: "Vetted close protection, asset security and residential teams — ex-military and law-enforcement professionals, operating worldwide.",
    pillars: [
      { icon: "ShieldCheck", title: "Close Protection", text: "Personal security for individuals and families." },
      { icon: "Lock", title: "Asset Transportation", text: "Secure movement of high-value assets." },
      { icon: "Sparkles", title: "Event Security", text: "Professional security for events of all sizes." },
      { icon: "Home", title: "Home & Estate Security", text: "Comprehensive risk analysis and mitigation." },
      { icon: "Users", title: "Ex-Military & Police", text: "Highly trained professionals from elite backgrounds." },
      { icon: "Eye", title: "Discreet & Confidential", text: "Your privacy and safety are our priority." },
      { icon: "Globe2", title: "Global Coverage", text: "Protection wherever you travel." },
      { icon: "Clock", title: "24/7 Response", text: "Rapid coordination, around the clock." },
    ],
    features: [
      "Close protection officers, vetted and discreet",
      "Residential and estate security teams",
      "Event and travel security planning",
      "24/7 rapid response coordination",
    ],
    hideGallery: true,
    gallery: ["/images/sec-1.jpeg", "/images/sec-2.jpeg", "/images/svc-security.jpeg"],
  },
  {
    id: "chauffeurs-transfers",
    name: "Chauffeurs & Transfers",
    tagline: "Arrive as you intend to be remembered.",
    description: "A fleet of marque vehicles with professional chauffeurs, airport meet-and-greet and discreet transfers — anywhere in the world, at any hour.",
    image: "/images/svc-chauffeurs.jpeg",
    secondary: IMAGES.cta,
    features: [
      "Marque fleet — Rolls-Royce, Bentley, Maybach",
      "Professional, discreet chauffeurs",
      "Airport meet and greet, worldwide transfers",
      "Wedding and occasion hire",
    ],
    hideGallery: true,
    gallery: ["/images/ch-1.jpeg", "/images/ch-2.jpeg", "/images/ch-3.jpeg", "/images/ch-4.jpeg"],
    fleetTitle: "Chauffeur Fleet",
    fleetHeading: "The right vehicle for every journey.",
    fleetMetricIcon: "gauge",
    fleet: [
      { type: "Luxury Saloon", name: "Mercedes-Benz S-Class", pax: 3, range: "Flagship", note: "The benchmark of chauffeur-driven comfort.", image: "/images/car-s.jpg" },
      { type: "Luxury MPV", name: "Mercedes-Benz V-Class", pax: 6, range: "Executive", note: "Spacious group travel without compromise.", image: "/images/car-v.jpg" },
      { type: "Electric Saloon", name: "BMW i7", pax: 3, range: "Electric", note: "Silent, zero-emission executive travel.", image: "/images/car-i7.jpg" },
      { type: "Luxury Saloon", name: "BMW 7 Series", pax: 3, range: "Flagship", note: "Executive presence, effortless comfort.", image: "/images/car-7.jpg" },
      { type: "Luxury SUV", name: "Range Rover Autobiography", pax: 4, range: "4×4", note: "Commanding presence, go-anywhere luxury.", image: "/images/car-rangerover.jpg" },
      { type: "Ultra-Luxury", name: "Rolls-Royce Ghost", pax: 3, range: "V12", note: "Post-opulence. An effortless arrival.", image: "/images/car-ghost.jpg" },
      { type: "Ultra-Luxury Flagship", name: "Rolls-Royce Phantom", pax: 3, range: "V12", note: "The finest motor car in the world.", image: "/images/car-phantom.jpg" },
      { type: "Ultra-Luxury", name: "Bentley Mulsanne", pax: 3, range: "V8", note: "Hand-built British grand touring.", image: "/images/car-mulsanne.jpg" },
      { type: "Electric Saloon", name: "Tesla Model S", pax: 3, range: "Electric", note: "Instant torque, minimalist luxury.", image: "/images/car-tesla.jpg" },
      { type: "Luxury Saloon", name: "Audi A8", pax: 3, range: "Quattro", note: "Understated German engineering.", image: "/images/car-a8.jpg" },
      { type: "Luxury People Carrier", name: "Mercedes-Benz Sprinter", pax: 8, range: "Group", note: "Jet-style cabin for parties and roadshows.", image: "/images/car-sprinter.jpg" },
    ],
  },
  {
    id: "supercar-hire",
    name: "Supercar Hire",
    tagline: "The driving seat of the latest machines.",
    headline: "Pure performance.",
    headlineItalic: "On demand.",
    description: "The newest supercars delivered to your door, your yacht or your hotel — with insurance, delivery and collection all arranged.",
    image: "/images/svc-supercar.jpeg",
    secondary: "/images/sc-4.jpeg",
    features: [
      "Latest Ferrari, Lamborghini and Porsche models",
      "Delivery to your door, yacht or hotel",
      "Fully insured, mileage-flexible packages",
      "Track-day experiences available",
    ],
    gallery: ["/images/sc-1.jpeg", "/images/sc-2.jpeg", "/images/sc-3.jpeg", "/images/sc-4.jpeg"],
    hideGallery: true,
    fleetTitle: "Supercar Collection",
    fleetHeading: "The world's most coveted marques.",
    fleetMetricIcon: "gauge",
    fleet: [
      { type: "Italian Marque", name: "Ferrari", pax: 2, range: "V8 / V12", note: "488, F8 Tributo, SF90 Stradale and more.", image: "/images/marq-ferrari.jpg" },
      { type: "British Marque", name: "Bentley", pax: 4, range: "W12", note: "Continental GT, Flying Spur and Bentayga.", image: "/images/marq-bentley.jpg" },
      { type: "British Marque", name: "Rolls-Royce", pax: 4, range: "V12", note: "Ghost, Phantom, Wraith and Cullinan.", image: "/images/marq-rollsroyce.jpg" },
      { type: "British Marque", name: "Aston Martin", pax: 2, range: "V8 / V12", note: "DB11, Vantage and DBS Superleggera.", image: "/images/marq-astonmartin.jpg" },
      { type: "German Marque", name: "Porsche", pax: 2, range: "Flat-Six", note: "911 Carrera, Turbo and GT3.", image: "/images/marq-porsche.jpg" },
      { type: "German Marque", name: "BMW", pax: 4, range: "M Power", note: "M4, M8 Competition and more.", image: "/images/marq-bmw.jpg" },
      { type: "German Marque", name: "Audi", pax: 2, range: "V10", note: "R8 and RS performance models.", image: "/images/marq-audi.jpg" },
      { type: "German Marque", name: "Mercedes-AMG", pax: 2, range: "V8", note: "AMG GT, G63 and S-Class Coupé.", image: "/images/marq-mercedes.jpg" },
      { type: "Italian Marque", name: "Lamborghini", pax: 2, range: "V10 / V12", note: "Huracán, Aventador and Urus.", image: "/images/marq-lamborghini.jpg" },
      { type: "Italian Atelier", name: "Pagani", pax: 2, range: "V12", note: "Huayra — automotive haute couture.", image: "/images/marq-pagani.jpg" },
      { type: "Swedish Atelier", name: "Koenigsegg", pax: 2, range: "Hybrid V8", note: "Agera and Jesko — megacar royalty.", image: "/images/marq-koenigsegg.jpg" },
      { type: "French Marque", name: "Bugatti", pax: 2, range: "W16", note: "Chiron — the pinnacle of speed.", image: "/images/marq-bugatti.jpg" },
      { type: "Italian Marque", name: "Maserati", pax: 2, range: "V6 / V8", note: "MC20 and GranTurismo.", image: "/images/marq-maserati.jpg" },
      { type: "British Marque", name: "McLaren", pax: 2, range: "V8", note: "720S, Artura and GT.", image: "/images/marq-mclaren.jpg" },
    ],
  },
  {
    id: "events-experiences",
    name: "Events & Experiences",
    tagline: "The party of the century, on your own private island.",
    headline: "Moments money can't buy.",
    headlineItalic: "Made yours.",
    description: "Wimbledon, Formula 1, Royal Ascot, Michelin-starred tables and private island celebrations — access to moments money alone cannot buy.",
    image: "/images/svc-events.jpeg",
    secondary: "/images/ev-main.jpeg",
    features: [
      "Wimbledon, Formula 1 and Royal Ascot hospitality",
      "Private island celebrations and weddings",
      "Michelin-starred tables, the best in the house",
      "Complete production, styling and guest management",
    ],
    gallery: ["/images/ev-1.jpeg", "/images/ev-2.jpeg", "/images/ev-3.jpeg", "/images/ev-4.jpeg", "/images/ev-5.jpeg", "/images/ev-6.jpeg", "/images/ev-7.jpeg", "/images/ev-8.jpeg", "/images/ev-9.jpeg", "/images/ev-10.jpeg", IMAGES.dining],
  },
  {
    id: "health-wellness",
    name: "Health & Wellness",
    tagline: "Performance begins with wellbeing.",
    headline: "Wellbeing,",
    headlineItalic: "without compromise.",
    description: "Private spas, leading healthcare experts and wellness retreats — access arranged for you, your family and your team.",
    image: "/images/wellness-spa.jpg",
    secondary: "/images/we-main.jpeg",
    features: [
      "Private spas and medi-clinics",
      "Leading practitioners brought directly to you",
      "Wellness retreats worldwide",
      "Personal trainers and nutritionists on call",
    ],
    gallery: ["/images/we-1.jpeg", "/images/we-2.jpeg", "/images/we-3.jpeg", "/images/we-4.jpeg", "/images/we-5.jpeg", "/images/we-6.jpeg", IMAGES.wellness, "/images/svc-wellness.jpeg"],
  },
  {
    id: "daily-needs",
    name: "Daily Needs",
    tagline: "Let us make your life easier.",
    headline: "Life's details.",
    headlineItalic: "Beautifully handled.",
    description: "Translations, removals, weddings, travel, visas, flight tickets and accommodation — any personal or corporate matter, handled quietly and completely.",
    image: "/images/svc-daily.jpeg",
    secondary: IMAGES.penthouse,
    featuresIntro: "Our daily lifestyle services include:",
    features: [
      "Private Chefs & In-Home Dining — Bespoke private chefs, meal preparation and in-home dining experiences tailored to your preferences.",
      "Chauffeur & Driver Services — Executive chauffeurs, personal drivers, airport transfers, daily transportation and school runs.",
      "Nannies & Childcare — Experienced childcare professionals, nannies and family support arranged according to your requirements.",
      "Domestic Staff — Housekeepers, maids, domestic cleaners, laundry services and other household support.",
      "Personal & Lifestyle Assistance — Errands, appointments, reservations, personal shopping, sourcing and other day-to-day requirements.",
      "Household Management — Ongoing coordination of household services and trusted specialists to ensure your home and daily requirements are managed seamlessly.",
    ],
    hideGallery: true,
    gallery: ["/images/svc-daily.jpeg", IMAGES.penthouse, "/images/re-bath.jpeg"],
  },
];

export const MEMBERSHIPS = [
  {
    id: "individual",
    name: "Individual",
    title: "Individual Membership",
    intro: "A personal one-to-one advisor, on hand around the clock, to arrange any request — regardless of the hour.",
    benefits: [
      "Dedicated one-to-one lifestyle advisor",
      "24-hour access to every service, worldwide",
      "Entry to prestigious private members' clubs",
      "Wimbledon, Formula 1, Royal Ascot and more",
      "Last-minute travel, security and reservations",
    ],
  },
  {
    id: "corporate",
    name: "Corporate",
    title: "Corporate Membership",
    intro: "Concierge privileges for your company and its people — convenience, care and competitive advantage.",
    benefits: [
      "Real estate, legal and financial advisors",
      "Business travel, security and transport",
      "Specialist recruitment and consultancy",
      "Staff wellbeing: spas and healthcare experts",
      "Preferential access across all services",
    ],
  },
];

export const WHY_PILLARS = [
  { icon: "Globe2", title: "Global Access", text: "A trusted network of partners across 25+ destinations worldwide." },
  { icon: "Clock", title: "24/7 Availability", text: "Round-the-clock support for last-minute and urgent requests." },
  { icon: "Lock", title: "Total Discretion", text: "Discreet, confidential and tailored to your personal needs." },
  { icon: "ShieldCheck", title: "Vetted Partners", text: "Every operator fully vetted and held to the highest standards." },
];

export const PROCESS_STEPS = [
  { icon: "MessageSquare", num: "01", title: "Enquire", text: "Tell us your plans and preferences." },
  { icon: "ClipboardList", num: "02", title: "We Plan", text: "We source the ideal options and create your itinerary." },
  { icon: "CalendarCheck", num: "03", title: "Confirm", text: "We handle every detail and confirm your booking." },
  { icon: "Sparkles", num: "04", title: "Enjoy", text: "A seamless experience from start to finish." },
  { icon: "Bell", num: "05", title: "We Follow Up", text: "We ensure every detail exceeded expectations." },
];

export const MENU_COLUMNS = [
  ["luxury-travel", "private-jet-charter", "helicopter-charter", "yacht-charter", "real-estate"],
  ["chauffeurs-transfers", "supercar-hire", "events-experiences", "security"],
  ["health-wellness", "daily-needs"],
];

export const FLAGSHIP_SERVICES = [
  "Luxury Travel",
  "Private Jet Charter",
  "Helicopter Charter",
  "Yacht Charter",
  "Real Estate",
  "Chauffeurs & Transfers",
  "Supercar Hire",
  "Events & Experiences",
  "Health & Wellness",
  "Daily Needs",
  "Security",
];

export const TIER_SERVICES = {
  Individual: [
    "Personal Shopping & Sourcing",
    "Art & Collectibles Access",
    "Global Lounge / Private Terminal Access",
    "Entertainment & Sporting Event Access",
    "Private Security & Protection Services",
    "Elite Social Club Access",
    "Fine Dining",
    "Jewellery Sourcing",
    "Import & Export Management",
    "Home Automation & Estate Technology",
    "Private Education & Tutoring",
  ],
  Corporate: [
    "Priority Chauffeur & Group Travel",
    "Corporate Flight Coordination",
    "VIP Airport & Lounge Access",
    "VIP Access to Global Events",
    "Tailored Corporate Retreats",
    "Corporate Housing Solutions",
    "Property Acquisition Support",
    "Relocations / Removals",
    "Private Security Services",
    "Fine Dining & Group Reservations",
    "Fine Dining",
    "Networking Event Planning & Access",
    "Employee & Client Incentives",
  ],
};


export const TESTIMONIALS = [
  {
    quote: "I used Delux Concierge for a last-minute trip to Singapore and everything was executed perfectly.",
    name: "Mr D. Song",
    role: "Investor, Singapore",
  },
  {
    quote: "Three weeks in the Mediterranean aboard a yacht I never once had to think about. The crew, the itinerary, the table in Portofino nobody could get — all of it simply appeared. I have stopped counting the favours; I have not stopped telling friends.",
    name: "Mrs E. Laurent",
    role: "Art Collector, Paris",
  },
  {
    quote: "A board meeting in Geneva was moved forward by a day. One message to my advisor and the jet, the car and the hotel suite were rearranged before my assistant had finished her coffee.",
    name: "Mr J. Whitfield",
    role: "Chief Executive, Private Equity",
  },
  {
    quote: "After eighteen months of searching on our own, Delux found our penthouse in six weeks — off-market, below the guide price, with every tedious detail handled before completion.",
    name: "Dr & Mrs A. Al-Rashid",
    role: "Private Clients, London",
  },
  {
    quote: "They found a dog sitter, a dentist and a table at a fully booked restaurant on the same afternoon. I still do not know how.",
    name: "Miss S. Beaumont",
    role: "Creative Director, New York",
  },
  {
    quote: "It is the only number I give my family when I travel. Whatever the hour, somebody answers — and somebody handles it.",
    name: "Mr K. Okafor",
    role: "Hotelier, Lagos",
  },
  {
    quote: "My wife's fiftieth is the evening our guests still talk about — the string quartet, the chef flown in from Lyon, the fireworks over the water. I gave them a date and a budget; they gave me a memory.",
    name: "Mr H. Gråberg",
    role: "Principal, Shipping Group",
  },
];